import {
  ChangeDetectionStrategy,
  Component,
  inject,
  signal,
} from '@angular/core';
import { CommonModule } from '@angular/common';
import { NzButtonModule } from 'ng-zorro-antd/button';
import { NzIconModule } from 'ng-zorro-antd/icon';
import { NzToolTipModule } from 'ng-zorro-antd/tooltip';
import { TranslatePipe } from '@shared/pipes/translate.pipe';
import { FeedbackDialogService } from '../feedback-dialog.service';

/**
 * Fixed-position floating button that opens the feedback modal
 * Only visible to authenticated users
 */
@Component({
  selector: 'app-feedback-button',
  standalone: true,
  imports: [CommonModule, NzButtonModule, NzIconModule, NzToolTipModule, TranslatePipe],
  templateUrl: './feedback-button.component.html',
  styleUrls: ['./feedback-button.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class FeedbackButtonComponent {
  private readonly feedbackDialog = inject(FeedbackDialogService);

  showPulse = signal(true);
  readonly feedbackOpen = this.feedbackDialog.isOpen;

  constructor() {
    // Hide pulse animation after 3 seconds
    setTimeout(() => {
      this.showPulse.set(false);
    }, 3000);
  }

  openFeedbackModal(): void {
    this.feedbackDialog.open();
  }

  handleKeydown(event: KeyboardEvent): void {
    if (event.key === 'Enter' || event.key === ' ') {
      event.preventDefault();
      this.openFeedbackModal();
    }
  }
}
